import { CONTAINER_NAME } from "../_utils/constant";
import { normalize } from "../common";
var vibrateShort = normalize(function (_ref) {
  var success = _ref.success,
      fail = _ref.fail,
      complete = _ref.complete;
  swan.vibrateShort({
    success: success,
    fail: fail,
    complete: complete
  });
}, CONTAINER_NAME.BAIDU);
export default vibrateShort;